// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"53e11a10","467":"97169cb8"}[chunkId] + ".chunk.js";
};